// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewDocumentary_videoModal__6mJQx {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999; /* Ensure it's above all other content */
}

.ViewDocumentary_modalContent__C611t {
  position: relative;
  width: 90%; /* Increased from 80% to use more screen space on mobile */
  max-width: 900px;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

.ViewDocumentary_closeButton__Rtg-A {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1001;
  color: white;
  transition: background-color 0.2s;
}

.ViewDocumentary_closeButton__Rtg-A:hover {
  background-color: rgba(255, 0, 0, 0.7);
}

/* Make the player responsive */
.ViewDocumentary_modalContent__C611t .plyr {
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
}

/* Increase the height of the progress bar for better touch targets */
.ViewDocumentary_modalContent__C611t .plyr--full-ui input[type="range"] {
  height: 20px; /* Increased height for better touch targeting */
}

.ViewDocumentary_modalContent__C611t .plyr__control--overlaid {
  padding: 20px; /* Larger play button */
}

.ViewDocumentary_modalContent__C611t .plyr__controls {
  padding: 15px; /* More padding in the controls area */
}

/* Force controls to be visible, especially on mobile */
.ViewDocumentary_modalContent__C611t .plyr--video .plyr__controls {
  opacity: 1 !important;
  visibility: visible !important;
}

/* Media query for mobile devices */
@media (max-width: 768px) {
  .ViewDocumentary_modalContent__C611t {
    width: 95%; /* Use almost full width on small screens */
    max-height: 80vh; /* Limit height on mobile */
  }
  
  /* Further increase the size of controls on small screens */
  .ViewDocumentary_modalContent__C611t .plyr__control {
    padding: 12px; /* Bigger buttons */
  }
  
  .ViewDocumentary_modalContent__C611t .plyr--full-ui input[type="range"] {
    height: 25px; /* Even bigger progress bar on mobile */
  }
  
  .ViewDocumentary_modalContent__C611t .plyr__controls {
    padding: 18px 10px; /* More vertical padding, less horizontal */
  }
  
  /* Hide all controls not needed on mobile */
  .ViewDocumentary_modalContent__C611t .plyr__volume,
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="mute"],
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="captions"],
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="settings"],
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="pip"],
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="airplay"],
  .ViewDocumentary_modalContent__C611t .plyr__time,
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="restart"],
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="rewind"],
  .ViewDocumentary_modalContent__C611t .plyr [data-plyr="fast-forward"] {
    display: none !important;
  }
  
  /* Make the progress bar more prominent */
  .ViewDocumentary_modalContent__C611t .plyr__progress {
    flex-grow: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/ViewDocumentary.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,0DAA0D;EACtE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,YAAY,EAAE,gDAAgD;AAChE;;AAEA;EACE,aAAa,EAAE,uBAAuB;AACxC;;AAEA;EACE,aAAa,EAAE,sCAAsC;AACvD;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU,EAAE,2CAA2C;IACvD,gBAAgB,EAAE,2BAA2B;EAC/C;;EAEA,2DAA2D;EAC3D;IACE,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,YAAY,EAAE,uCAAuC;EACvD;;EAEA;IACE,kBAAkB,EAAE,2CAA2C;EACjE;;EAEA,2CAA2C;EAC3C;;;;;;;;;;IAUE,wBAAwB;EAC1B;;EAEA,yCAAyC;EACzC;IACE,YAAY;EACd;AACF","sourcesContent":[".videoModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgb(0 0 0);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999; /* Ensure it's above all other content */\n}\n\n.modalContent {\n  position: relative;\n  width: 90%; /* Increased from 80% to use more screen space on mobile */\n  max-width: 900px;\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 1001;\n  color: white;\n  transition: background-color 0.2s;\n}\n\n.closeButton:hover {\n  background-color: rgba(255, 0, 0, 0.7);\n}\n\n/* Make the player responsive */\n.modalContent :global(.plyr) {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n}\n\n/* Increase the height of the progress bar for better touch targets */\n.modalContent :global(.plyr--full-ui input[type=\"range\"]) {\n  height: 20px; /* Increased height for better touch targeting */\n}\n\n.modalContent :global(.plyr__control--overlaid) {\n  padding: 20px; /* Larger play button */\n}\n\n.modalContent :global(.plyr__controls) {\n  padding: 15px; /* More padding in the controls area */\n}\n\n/* Force controls to be visible, especially on mobile */\n.modalContent :global(.plyr--video .plyr__controls) {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n/* Media query for mobile devices */\n@media (max-width: 768px) {\n  .modalContent {\n    width: 95%; /* Use almost full width on small screens */\n    max-height: 80vh; /* Limit height on mobile */\n  }\n  \n  /* Further increase the size of controls on small screens */\n  .modalContent :global(.plyr__control) {\n    padding: 12px; /* Bigger buttons */\n  }\n  \n  .modalContent :global(.plyr--full-ui input[type=\"range\"]) {\n    height: 25px; /* Even bigger progress bar on mobile */\n  }\n  \n  .modalContent :global(.plyr__controls) {\n    padding: 18px 10px; /* More vertical padding, less horizontal */\n  }\n  \n  /* Hide all controls not needed on mobile */\n  .modalContent :global(.plyr__volume),\n  .modalContent :global(.plyr [data-plyr=\"mute\"]),\n  .modalContent :global(.plyr [data-plyr=\"captions\"]),\n  .modalContent :global(.plyr [data-plyr=\"settings\"]),\n  .modalContent :global(.plyr [data-plyr=\"pip\"]),\n  .modalContent :global(.plyr [data-plyr=\"airplay\"]),\n  .modalContent :global(.plyr__time),\n  .modalContent :global(.plyr [data-plyr=\"restart\"]),\n  .modalContent :global(.plyr [data-plyr=\"rewind\"]),\n  .modalContent :global(.plyr [data-plyr=\"fast-forward\"]) {\n    display: none !important;\n  }\n  \n  /* Make the progress bar more prominent */\n  .modalContent :global(.plyr__progress) {\n    flex-grow: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoModal": `ViewDocumentary_videoModal__6mJQx`,
	"modalContent": `ViewDocumentary_modalContent__C611t`,
	"closeButton": `ViewDocumentary_closeButton__Rtg-A`
};
export default ___CSS_LOADER_EXPORT___;
